<template>
  <div class="t-container ">
    <v-data-table
      v-if="showTable"
      v-model="selected"
      :headers="headers"
      :items="users"
      :item-class="rowClass"
      item-key="email"
      single-select
      :search="search"
      :loading="loading"
    >
      <template v-slot:loading>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>

      <template
        v-if="hasViewActivityLogPermission"
        v-slot:item.actions="{ item }"
      >
        <div class="row actions">
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              alt="View"
              class="bi bi-eye action_item"
              viewBox="0 0 16 16"
              @click="view(item)"
            >
              <path
                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
              />
              <path
                d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
              />
            </svg>
          </p>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-trash action_item"
              alt="Delete"
              viewBox="0 0 16 16"
              @click="sendUser(item)"
            >
              <path
                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
              />
              <path
                fill-rule="evenodd"
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
              />
            </svg>
          </p>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-pencil action_item"
              viewBox="0 0 16 16"
              alt="Edit"
              @click="editPermissions(item)"
            >
              <path
                d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 
            .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
              />
            </svg>
            <i class="bi bi-pencil"></i>
          </p>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<style></style>
<script>
import { API, Auth } from "aws-amplify";
import UserListingPermissionsMixin from "@/components/userlisting/UserListingPermissionsMixin.js";

export default {
  mixins: [UserListingPermissionsMixin],
  props: {
    search: {
      type: String,
      required: false
    },
    value: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      users: []
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    showTable() {
      return !!this.headers.length;
    },
    loading() {
      return !(!!this.users && this.users.length);
    },
    getUsersEndpoint() {
      return this.isAdmin
        ? "/listUsersWithGroups"
        : "/listMerchantUsersWithGroups";
    },
    headers() {
      const headers = [];
      if (this.isAdmin) {
        headers.push({ text: "Company", value: "company", align: "left" });
      }
      headers.push({ text: "Name", value: "name", align: "left" });
      headers.push({ text: "Role", value: "role", align: "left" });
      headers.push({ text: "Email", value: "email", align: "left" });

      if (this.hasViewActivityLogPermission)
        headers.push({
          text: "Action",
          value: "actions",
          sortable: false,
          align: "left"
        });
      return headers;
    },
    showSelect() {
      return this.hasViewActivityLogPermission || this.hasDeleteUserPermissions;
    }
  },
  methods: {
    sendUser(val) {
      this.$emit("deleted", val);
    },
    editPermissions(item) {
      this.$emit("editPermissions", item);
    },
    rowClass() {
      const rowClass = "table-rows";
      return rowClass;
    },
    view(item) {
      this.$emit("view", item);
    },
    loadUsers: async function() {
      let response = await this.getUsers();
      let users = [];
      response.Users.forEach(data => {
        users.push(this.extractAttributes(data));
      });
      return users;
    },
    getUsers: async function() {
      let payload = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`
        }
      };

      return await API.get("AdminQueries", this.getUsersEndpoint, payload);
    },
    extractSingleAttribute(attributes, name, defaultValue) {
      defaultValue = defaultValue ?? "";
      let attribute = attributes.find(e => e.Name == name);
      attribute = !!attribute ? attribute.Value : defaultValue;

      return attribute;
    },
    extractAttributes(data) {
      let role = "";
      if (!!data.Groups) {
        role = this.checkRole(data.Groups.map(e => e.GroupName));
      }

      const attributes = data.Attributes;
      const email = this.extractSingleAttribute(attributes, "email");
      const name = this.extractSingleAttribute(attributes, "name");
      const username = data.Username;

      const company = this.isAdmin
        ? this.extractSingleAttribute(attributes, "family_name")
        : null;

      return {
        username,
        name,
        email,
        company,
        role
      };
    },
    checkRole(groups) {
      if (groups.includes("Admin")) return "Admin";
      if (groups.includes("MerchantAdmin")) return "MerchantAdmin";
      return "User";
    }
  },
  created: async function() {
    this.loadUsers()
      .then(result => {
        this.users = result;
      })
      .catch(e => {
        this.$logger.error(e);
      });
  }
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.action_item {
  margin-right: 10px;
  cursor: pointer;
}
.action_item:hover {
  color: #aaa3da;
}
</style>
